<template>
  <div class="initiativel">
    <h1 style="font-weight:700;">館員如何提倡開放取用</h1>
    <h3 style="font-weight:500;">為學術文獻和和研究資料設立一個開放取用、符合OAI-PMH規範的機構典藏</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>

        ● 大學設立機構典藏的主要目的是為了強化大學研究產出的能見度、可取得性和影響力，藉此提高研究、教師和機構本身的形象。
      </li>
      <p style="line-height:2;"></p>

<li>

        ● 更明確的理由是有越來越多的期刊讓作者在所屬機構中存放作者定稿本，但不存放於學科領域的典藏庫。因此一個沒有機構典藏的大學將造成其教師無從提供研究開放取用。
      </li>
      <p style="line-height:2;"></p>
      <li>

        ● 「符合OAI規格」是指機構典藏遵守開放典藏詮釋資料擷取協定(OAI-PMH)。如此一來便能與其他符合OAI-PMH規格的機構典藏互通，讓多個分散的機構典藏如同一個整體的虛擬機構典藏般運作，以符合搜尋的需求。也就是說，使用者可以跨多個符合OAI-PMH規格的機構典藏來進行搜尋，毋須逐一拜訪個別的機構典藏進行獨立搜尋。因此即便使用者不知道貴單位有機構典藏，或者不知道機構典藏的內容，依然能使內容更容易被看見。相關網址：<a href="http://www.openarchives.org/">http://www.openarchives.org/</a>
      </li>
      <p style="line-height:2;"></p>
      <li>

        ● 以下提供一些可以用來創立和維持符合OAI-PMH規格的機構典藏開放原始碼軟體。其中最重要的四套為：南安普敦大學的Eprint、麻省理工學院的DSapce、歐洲核子研究組織的CDSWare和康乃爾大學與維吉尼亞大學的FEDORA。相關網址：<a href="http://www.eprints.org/software/">http://www.eprints.org/software/</a>
      </li>
      <p style="line-height:2;"></p>
    </ul>


    <br>
    <h3 style="font-weight:500;">協助教師將研究論文上傳至機構典藏</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>

        ● 許多教師都非常願意將他們的研究論文上傳至機構典藏，只是有時礙於太過於忙碌而無法處理。有部分是源於對科技的排斥恐懼，也有另一部分是需要有人向他們說明此事的益處。
      </li>
      <p style="line-height:2;"></p>

<li>

        ● 舉例來說，有些大學圖書館由專職館員拜訪各教師，一間間研究室逐一敲門，協助他們將研究論文上傳到機構典藏。聖安德魯斯大學則請教師將他們的文章透過電子郵件，以附件形式寄至圖書館，接著圖書館員便會將資料上傳至機構典藏。
      </li>
      <p style="line-height:2;"></p></ul>
      <br>
<h3 style="font-weight:500;">考慮出版開放取用的期刊。下述有一些初期的例子但此非完整清單。</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>

        ● 密西根大學的<span style="font-style:italic;">Philosopher’s Imprint</span>是開放取用期刊，其理念為：「由教授編輯、圖書館館員出版，免費提供給網路上的所有讀者。」由於編輯和出版者(教師和館員)原本便已受僱於大學，<span style="font-style:italic;">Philosopher’s Imprint</span>可歸類為由大學補助的開放取用期刊，因此不需要另收取文章處理費。相關網址：<a href="http://www.philosophersimprint.org/">http://www.philosophersimprint.org/</a>
      </li>
      <p style="line-height:2;"></p>

<li>

        ● 圖森的亞歷桑那大學圖書館出版開放取用且有同儕審查的期刊：<span style="font-style:italic;">Journal of Insect Science</span>。相關細節以及省思，請參考(1)Henry Hagedorn等人於2004年一月的研討會論文，由 Academic Library出版；以及(2)Eulalia Roel發表於2004年一月College & Research Libraries News中的文章：A new library contribution to scholarly communication。
      </li>
      <p style="line-height:2;"></p>

<li>

        ● 波士頓學院圖書館出版之開放取用期刊，係由該校教師進行編輯審查。查看該館在2004年12月16日後的新聞稿，請前往下述網址：<a href="http://www.bc.edu/libraries/">http://www.bc.edu/libraries/</a>
      </li>
      <p style="line-height:2;"></p>
      <li>

        ● 開放取用期刊Digital Information現由德州農工大學圖書館出版。網址為：<a href="http://jodi.tamu.edu/">http://jodi.tamu.edu/</a>
      </li>
      <p style="line-height:2;"></p>






    </ul>


    <br>
<h3 style="font-weight:500;">考慮拒絕套裝優惠採購方案（Big Deal）或刪訂那些無法為他們的高昂價格提出合理說明或者發出公開說明原因的期刊</h3>
    <ul class="txt1" style="text-indent : -1em ;">
      <li>

        ● 下列清單（<a href="http://www.earlham.edu/~peters/fos/lists.htm#actions">http://www.earlham.edu/~peters/fos/lists.htm#actions</a>）羅列出已經做出上述行動的大學。若是這份清單為您帶來勇氣和想法，請您一定要意識到，您也可以為其他人做相同的事。
      </li>
      <p style="line-height:2;"></p>

<li>

        ● 在行政會議、研究發展會議、圖書館委員會、或者到個別的系所做簡報，向教師或行政主管說明學術傳播的危機，以及開放取用是整體性的解決方案之一。您會需要教師和行政主管來支持這些決定，目前已有其他大學已經成功達成了。
      </li>
      <p style="line-height:2;"></p>







    </ul>
    <br>
    <h3 style="font-weight:500;">不僅為教師提供數位化、取用和保存的計畫，同時也為地方團體，例如非營利組織、社區機構、博物館、美術館、圖書館等提供協助。向大學周圍的非學術團體展現開放取用的優點，特別是非營利的社群團體。</h3>
    <br>
    <h3 style="font-weight:500;">加入SPARC，這是一個致力於提倡開放取用的學術圖書館聯盟。相關網址：<a href="http://www.arl.or./sparc/">http://www.arl.or./sparc/</a></h3>

  </div>
</template>
<script>
export default {
  name: 'Initiativel',
  data() {

  }
}

</script>
<style>
/*@font-face {
  font-family: Times New Roman;
  src: url(DroidSans.woff);
  unicode-range: U+000-5FF, U+1e00-1fff, U+2000-2300;
}*/


.initiativel {
  padding: 4%;
  padding-top: 2%;
  background-color: rgba(248, 194, 88,0.1);
  box-shadow: 0 5px 5px -2px rgba(0, 0, 0, .2);
  padding-bottom: 50px;

}



.txt {


  font-size: 20px;
  text-align: left;
  text-indent: 2em;
  font-weight: 500;

}

.txt1 {

  line-height: 1.5;
  font-size: 20px;
  text-align: left;
  padding-left: 12px;
  font-weight: 500;

}

</style>
